import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { BookContext } from "../contexts/BookContext";

export const DashboardTopBar = () => {
  const { t } = useTranslation();
  const upsellUrl = import.meta.env.VITE_MEMOIRS_UPSELL_AUDIO_URL;
  const { subscription } = useContext(BookContext);
  const withAudio = subscription?.with_audiobook;
  return (
    <div className="bg-white flex flex-col lg:flex-row justify-between shadow-md rounded py-4">
      <div className="w-full lg:w-6/12 border-b-2 lg:border-b-0 lg:border-r-2 border-rust-500 px-4 sm:px-6 pb-4 lg:pb-0">
        <p className="text-slate-700 text-xl sm:text-2xl font-bold">
          {t("dashboard.book_of_your_life")}
        </p>
        <p className="text-slate-50 text-sm sm:text-md">
          {t("dashboard.book_of_your_life_description")}
        </p>
      </div>
      <div className="w-full lg:w-6/12 px-4 sm:px-6 pt-4 lg:pt-0">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-6 justify-between flex-1">
          {!withAudio && (
            <>
              <div className="w-full lg:w-7/12 flex flex-col">
                <p className="text-slate-700 text-xl sm:text-2xl font-bold">
                  {t("dashboard.available_offers")}
                </p>
                <p className="text-slate-50 text-sm sm:text-md">
                  {t("dashboard.audioBookDescription")}
                </p>
              </div>
              <div className="w-full lg:w-5/12 justify-center flex flex-col items-center">
                <a
                  href={upsellUrl}
                  target="_blank"
                  className="bg-rust-500 hover:bg-rust-800 text-sm text-white rounded px-4 py-2 flex items-center justify-center w-full lg:w-auto"
                >
                  <ShoppingCartIcon className="h-5 w-5 mr-2" />
                  {t("dashboard.buy_now")}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
